// extracted by mini-css-extract-plugin
export var body = "_dv-0";
export var sectionHeader = "_dv-4";
export var shortcutColumns = "_dv-2";
export var shortcutList = "_dv-1";
export var shortcutSection = "_dv-3";